<template>


<div class="title-i"> <i class="bi bi-easel2-fill" style="color: #e4bb3e"></i> Hot News</div>


                <button type="button" class="btn btn-success btn-sm morebt"
                    @click="gotoBulletinAll">More News</button>

                <table class="tbl">
                    <thead>
                        <tr>
                            <td class="tbl-thead" style="text-align: left;">{{ $t("Bulletin.PostTitle") }}</td>
                            <td class="tbl-thead" style="text-align: left;">{{ $t("Bulletin.PostSystem") }}</td>
                            <td class="tbl-thead" style="text-align: left;">{{ $t("Bulletin.PostDate") }}</td>
                        </tr>
                    </thead>
                    <tbody>

                    <tr  v-for="item in data" v-bind:key="item.Pkey">
                       <td style="text-align: left;"><i class="bi bi-caret-right-fill arrowcr"></i>
                        <router-link :to="{ name: 'bulletinView', params: { id: item.Pkey }}">{{ item.Title }} </router-link>
                      </td>
                        <td class="text-center"> {{ item.VIPSystem }} </td>
                        <td  class="text-center">{{ format_date_yyyyMMdd(item.CreateDate) }}</td>
                      </tr>


                        
                    </tbody>
                </table>

   
 </template>

<script>

import CommonService from "../service/CommonService";
import BulletinService from "../service/BulletinService";
export default {
name: 'Bulletin',
BulletinService: null,
CommonService: null,
props: ["isTop5"],
data() {
   return {
       systems:[],
       data:[],
  
   };
},
created() {
    let self=this;
    this.CommonService = new CommonService();
    this.BulletinService = new BulletinService();

    this.CommonService.GetSystems()
            .then((data) => {
            //    console.log(data);
               self.systems=data;
            })


       this.get();
    },
    watch: {
        isTop5: function () {
            this.get(); 
            },
          },
    computed: {
    isLoading() {
      return this.$store.state.isLoading;
     },
    user() {
     return this.$store.state.user;
    },
    user_Id() {
     return this.$store.state.user?.id;
    },
    user_userName() {
     return this.$store.state.user?.userName;
    },
    user_bg() {
     return this.$store.state.user?.bg;
    },
    user_buyerMapping() {
     return this.$store.state.user?.buyerMapping;
    },
    user_sourcerMapping() {
     return this.$store.state.user?.sourcerMapping;
    },
    user_vendorMapping() {
     return this.$store.state.user?.vendorMapping;
    },
    user_mfgcode() {
     return this.$store.state.user?.mfgcode;
    },
    user_mfgsearchterm() {
     return this.$store.state.user?.mfgsearchterm;
    },
    user_roles() {
     return this.$store.state.user?.Roles;
    },
    clientId() {
     return this.$store.state.user?.clientId;
    },

    token() {
     return this.$store.state.token;
    },
    refreshToken() {
     return this.$store.state.refreshToken;
    },
    sessionCode() {
     return this.$store.state.sessionCode;
    },


     


  },
    methods: {
      goto(id) {
            this.$router.push({
                name: 'bulletinView', params: { id: id }
            })
        },
        get() 
        {
            console.log(this.isTop5)
            let self=this;
            if(this.isTop5 && this.isTop5==true){
                this.BulletinService.GetBulletinBoardTop5()
                    .then((data) => {
                    //    console.log(data);
                        self.data=data;
                    })
            }
            else {
                this.BulletinService.GetBulletins()
                    .then((data) => {
                    //    console.log(data);
                    self.data=data;
                    })
            }
          
        },
        getSystem(system) 
        {
            let self=this;
           this.BulletinService.GetBulletinBoardBySystem(system)
            .then((data) => {
            //    console.log(data);
               self.data=data;
            })
        },
        gotoBulletinAll(){
            this.$router.replace("/bulletinAll");

        }
      }
}
</script>
 